/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AsanaHistoryEntry } from '../models/AsanaHistoryEntry';
import type { PaginatedAsanaHistoryEntryList } from '../models/PaginatedAsanaHistoryEntryList';
import type { PatchedAsanaHistoryEntry } from '../models/PatchedAsanaHistoryEntry';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AsanaHistoryEntriesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedAsanaHistoryEntryList
     * @throws ApiError
     */
    public asanaHistoryEntriesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedAsanaHistoryEntryList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/asana-history-entries/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns AsanaHistoryEntry
     * @throws ApiError
     */
    public asanaHistoryEntriesCreate({
        requestBody,
    }: {
        requestBody: AsanaHistoryEntry,
    }): CancelablePromise<AsanaHistoryEntry> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/asana-history-entries/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AsanaHistoryEntry
     * @throws ApiError
     */
    public asanaHistoryEntriesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this asana history entry.
         */
        id: number,
    }): CancelablePromise<AsanaHistoryEntry> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/asana-history-entries/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns AsanaHistoryEntry
     * @throws ApiError
     */
    public asanaHistoryEntriesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this asana history entry.
         */
        id: number,
        requestBody: AsanaHistoryEntry,
    }): CancelablePromise<AsanaHistoryEntry> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/asana-history-entries/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AsanaHistoryEntry
     * @throws ApiError
     */
    public asanaHistoryEntriesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this asana history entry.
         */
        id: number,
        requestBody?: PatchedAsanaHistoryEntry,
    }): CancelablePromise<AsanaHistoryEntry> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/asana-history-entries/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public asanaHistoryEntriesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this asana history entry.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/asana-history-entries/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
